import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { checkCreateEdit } from "../../../application/common/utils/roles-helper";
import { Modules } from "../../../application/common/enums/screen-name";
import { Box, Button, Container, Grid, Typography, useTheme, } from "@mui/material";
import { Plus } from "@phosphor-icons/react/dist/ssr";
const CompanyRoleTopHeader = ({ openPopup, translate }) => {
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const theme = useTheme();
    return (_jsx(Container, { disableGutters: true, sx: { maxWidth: "100% !important" }, children: _jsxs(Grid, { container: true, spacing: 2, sx: {
                alignItems: "center"
            }, children: [_jsx(Grid, { size: {
                        xs: 6,
                        sm: 6,
                        md: 6
                    }, children: _jsx(Box, { sx: { padding: "24px 0px" }, children: _jsx(Typography, { variant: "h1", sx: { color: theme.palette.text.primary }, children: translate("CompanyRole") }) }) }), _jsx(Grid, { sx: { textAlign: "right" }, size: {
                        xs: 6,
                        sm: 6,
                        md: 6
                    }, children: checkCreateEdit(RolesPermissions, Modules.RoleManagement) && (_jsx(Button, { variant: "contained", size: "medium", startIcon: _jsx(Plus, {}), onClick: openPopup, children: translate("NewRole") })) })] }) }));
};
export default CompanyRoleTopHeader;
